import { PaginatorLabelsService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomPaginatorLabels extends PaginatorLabelsService {

  pageSizeSelectorLabel = 'Items per page:';
  ofLabel = 'of';

  constructor(public translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe((e: Event) => {
      this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.translate.get(['RPA_BOTS.ITEMS_PAGE', 'RPA_BOTS.OF_LABEL']).subscribe(translation => {
      this.pageSizeSelectorLabel = translation['RPA_BOTS.ITEMS_PAGE'];
      this.ofLabel = translation['RPA_BOTS.OF_LABEL'];
    });
  }

  /** Label for the range of items */
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) { return `0 ${this.ofLabel} ${length}`; }

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
  }
}
